import React from "react";
import { Provider } from "react-redux";
import { store} from "../../redux/store";
import {confirmAlert} from "react-confirm-alert";

const ModalFormContainer = (Children, props={}) => confirmAlert({
    closeOnEscape: props.closeOnEscape == null ? false : props.closeOnEscape,
    closeOnClickOutside: props.closeOnClickOutside == null ? false : props.closeOnClickOutside,
    customUI: ({onClose}) => <Provider store={store}>
        <Children
            onClose={onClose}
            {...props}
        />
    </Provider>
})

export { ModalFormContainer }
